<template>
  <li class="subscription-plan-features-item">
    <CheckIcon
      class="subscription-plan-features-item__icon"
      aria-hidden="true"
    />
    {{ feature }}
  </li>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/20/solid'

type Props = {
  feature: string
}
defineProps<Props>()
</script>

<style>
.subscription-plan-features-item {
  @apply flex gap-x-3;

  &__icon {
    @apply h-6 w-5;
    @apply flex-none;
    @apply text-indigo-600 dark:text-indigo-400;
  }
}
</style>
